import React, { Component, Fragment, lazy, Suspense } from 'react';
import { compose }          from 'redux';
import { connect }          from 'react-redux';
import { Switch, Route, withRouter, Redirect }    from 'react-router-dom';

//Import components
import Header     from './containers/header/header';
import Footer     from './containers/footer/footer';
import Loader     from './components/common/loader/loader';
import Home       from './containers/home/home';
import Popups     from './containers/popups';
import BurgerMenu from './containers/burger/burger';
import Error      from './containers/content/errorPage/index';
import Splash     from './containers/splash/splash';
import CookieMsg  from './containers/cookiesMsg/index';
import MetaTags   from './containers/metaTags/metaTags';
import ScrollToTop from 'components/routing/scroll_top';

//css
import './scss/app.scss';
import './scss/animations.scss';

//routing constants
import * as routes from './constants/routes';

//actions
import { getGeneralDeclaration, getFavoriets } from 'redux/actions';
import {getLocalStorageItem} from "./app/static_func";
import * as keys from "./constants/storage-keys";

//begin code splitting
const Results       = lazy(()=> import('containers/results/results'));
const Car           = lazy(()=> import('containers/car/car'));
const Order         = lazy(()=> import('containers/order/order'));
const About         = lazy(()=> import('containers/content/about/index'));
const howItWorks    = lazy(()=> import('containers/content/howItWorks/index'));
const Contact       = lazy(()=> import('containers/content/contact/index'));
const Content       = lazy(()=> import('containers/content/contentPage/index'));
const QA            = lazy(()=> import('containers/content/qestions_answers/qa'));
const Questionnaire = lazy(()=> import('containers/Questionnaire/questionnaire'));
const ScreenSaver   = lazy(()=> import('containers/screenSaver'));

class App extends Component {

    componentDidMount() {
        this.props.getGeneralDeclaration();

        if (JSON.parse(getLocalStorageItem(keys.FAVORITES)) === null){
            this.props.getFavoriets({licenseNumbers: 0})
        }
        else
            this.props.getFavoriets({licenseNumbers: JSON.parse(getLocalStorageItem(keys.FAVORITES))});
    }

    render() {

        var isMobile         = (this.props.deviceState !== 'desktop'),
            showPopup        = this.props.popupsArray.length > 0,
            showBurgerMenu   = isMobile && this.props.burgerMenuState,
            animateBurger    = isMobile && this.props.burgerMenuAnimate,
            showLoader       = this.props.showLoader,
            showSplashScreen = false;

        if(showBurgerMenu) {
            document.body.classList.add('burger');
        } else {
            document.body.classList.remove('burger');
        }


        const res = this.props.location.pathname.split('/');

        if(!showSplashScreen || !this.props.routeTable) {
            return (
                <Fragment>
                    <div className={ 'app' + (res[1] === 'car' ? ' car' : '') + (animateBurger ? ' burger' : '')}>
                        <Header history={this.props.history} />
                        {this.props.routeTable &&
                        <main className="main">
                            <Switch>
                                <Route exact path={'/'}>
                                    <Redirect to={routes.home}/>
                                </Route>
                                <Route exact path={routes.home} component={Home}/>
                                <Route exact path={routes.results + '/:query?'} render={LazyLoadComponent(Results)}/>
                                <Route path={routes.car + '/:licenseNumber/:title'} render={LazyLoadComponent(Car)}/>
                                <Route path={routes.Order + '/:licenseNumber'} render={LazyLoadComponent(Order)}/>
                                <Route exact path={routes.about} render={LazyLoadComponent(About)}/>
                                <Route exact path={routes.howItWorks} render={LazyLoadComponent(howItWorks)}/>
                                <Route exact path={routes.contact} render={LazyLoadComponent(Contact)}/>
                                <Route exact path={routes.content} render={LazyLoadComponent(Content)}/>
                                <Route exact path={routes.qa} render={LazyLoadComponent(QA)}/>
                                <Route exact path={routes.match} render={LazyLoadComponent(Questionnaire)}/>
                                <Route exact path={routes.placeholder} render={LazyLoadComponent(ScreenSaver)}/>
                                <Route exact path={routes.error} component={Error}/>
                                <Route render={LazyLoadComponent(Content)}/>
                            </Switch>
                        </main>
                        }
                        {!this.props.routeTable && <Splash/>}
                        <Footer />
                        <MetaTags/>
                        <CookieMsg/>
                        { showPopup && <Popups history={this.props.history}/>}
                        { showLoader && <Loader /> }
                    </div>
                    { showBurgerMenu && <BurgerMenu />}
                    <ScrollToTop/>
                </Fragment>
            )
        } else {
            return (
                <Splash />
            )
        }
    }
}

function LazyLoadComponent(Component) {
    return props => (
        <Suspense fallback={<Loader className="full-screen" />}>
            <Component {...props} />
        </Suspense>
    );
}

//get required state from redux store and map them to the components props
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        showLoader: store.state.showLoader,
        popupsArray: store.state.popupsArray,
        burgerMenuState: store.state.burgerMenuState,
        burgerMenuAnimate: store.state.burgerMenuAnimate,
        routeTable: store.config.RouteTable,
        tags: store.data.Tags,
    }
};
//map a actions to props
const mapDispatchToProps = dispatch => {
    return {
        getGeneralDeclaration: () => dispatch(getGeneralDeclaration()),
        getFavoriets: (payload)=> dispatch(getFavoriets(payload)),
    }
};
export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps, null, { pure: false })
)(App);

